import { FaqRoutingModule } from './../../faq/faq-routing.module';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ListService } from '../list.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CreateComponent } from '../create/create.component';
import { DetailsBlogComponent } from '../details-blog/details-blog.component';
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  page = 1;
  totalPages = 0;
  faqList: any = [];
  nameLength = 12;
  base_url = environment.baseUrl;
  constructor(
    private faq: ListService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {}

  openDialog(item: any) {
    console.log(item, 'ajjja');
    window.open(`${environment.website}/blog/${item?.slug}`, '_blank');

    // const dialogRef = this.dialog.open(DetailsBlogComponent, {
    //   height: '100vh',
    //   data: {
    //     content: item?.content,
    //   },
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   console.log(`Dialog result: ${result}`);
    // });
  }
  ngOnInit(): void {
    this.showAll();
  }
  showAll() {
    this.spinner.show();
    this.faq.list(this.page).subscribe((data: any) => {
      console.log(data);
      this.page = data?.data?.current_page;
      this.totalPages = data?.data?.last_page;
      // Merge new data into the existing list
      this.faqList.push(...data.data?.data);
      // Sort so that published items (is_published === 1) appear first
      this.faqList.sort((a, b) => b.is_published - a.is_published);
      // Save sorted list to localStorage
      localStorage.setItem('blogs', JSON.stringify(this.faqList));
      this.spinner.hide();
    });
  }
  loadMore() {
    if (this.page < this.totalPages) {
      this.page++;
      this.faq.list(this.page).subscribe((data: any) => {
        this.faqList.push(...data.data?.data);
        localStorage.setItem('blogs', JSON.stringify(this.faqList));
      });
    }
  }
  delete(service_id) {
    Swal.fire({
      title: `يرجي الانتاه`,
      text: `هل انت متأكد من حذف المقال !`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'نعم',
      cancelButtonText: 'لا',
    }).then((result) => {
      if (result.value) {
        return this.faq
          .delFaq(service_id)
          .pipe()
          .subscribe((response) => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'تم الحذف بنجاح',
              showConfirmButton: false,
              timer: 1500,
            });
            this.showAll();
          });
      }
    });
  }
  deActivate(service) {
    this.spinner.show();

    this.faq.togglePublish({ blog_id: service?.id }).subscribe((response) => {
      if (service.is_published == 0) {
        service.is_published = 1;
      } else {
        service.is_published = 0;
      }
      this.spinner.hide();
    });
  }
  drop(event: CdkDragDrop<any[]>) {
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;

    const previousItem = this.faqList[previousIndex];
    const currentItem = this.faqList[currentIndex];

    console.log('🔁 تم سحب العنصر:', previousItem, 'رقمه:', previousIndex);
    console.log('⬇️ وأسقط عند العنصر:', currentItem, 'رقمه:', currentIndex);
    let form: any = {
      from_blog_id: currentItem?.id,
      to_blog_id: previousItem?.id,
      from_index: previousIndex,
      to_index: currentIndex,
    };
    console.log('Form data to update index:', form);

    // إذا كنت تريد تحديث الترتيب فعليًا:
    moveItemInArray(this.faqList, previousIndex, currentIndex);
    this.faq.updateIndex(form).subscribe((response) => {
      console.log(response);
    });
  }
}
